<template>
  <div>
    <a-spin :spinning="pageLoading" tip="加载中...">
      <div class="storage-overview">
        <div class="info-section">
          <div class="info-left">
            <div class="card-header">
              <a-select
                v-model="selectedTenant"
                style="width: 200px; margin-left: 10px"
                size="large"
                @change="handleTenantChange"
              >
                <a-select-option v-for="tenant in tenants" :key="tenant.id" :value="tenant.id">
                  {{ tenant.name }}
                </a-select-option>
              </a-select>
            </div>

            <div class="info-grid">
              <div class="info-row">
                <div class="info-group">
                  <div class="info-label">存储类型</div>
                  <div class="info-value">{{ packageName }}</div>
                </div>
                <div class="info-group">
                  <div class="info-label">存储模式</div>
                  <div class="info-value">{{ storageMode }}</div>
                </div>
              </div>

              <div class="info-row">
                <div class="info-group">
                  <div class="info-label">生效时间</div>
                  <div class="info-value">{{ effectiveTime }}</div>
                </div>
                <div class="info-group">
                  <div class="info-label">到期时间</div>
                  <div class="info-value" :class="{ expired: isExpired }">{{ expireTimeText }}</div>
                </div>
              </div>
            </div>

            <div class="storage-section" v-if="hasPackage">
              <div class="storage-left">
                <div class="storage-item">
                  <div class="storage-label">剩余存储</div>
                  <div class="storage-value">{{ $formatCapacity(remainingStorage) }}</div>
                </div>
                <div class="storage-item" v-if="showShareButton && getType === 1">
                  <div class="storage-value">
                    <a-button icon="share-alt" type="primary" @click="handleShareCapacity"> 容量分配 </a-button>
                  </div>
                </div>
                <!-- v-if="showRenewButton" -->
                <div class="storage-item">
                  <div class="storage-value">
                    <a-button type="primary" @click="handleRenew(1)" v-if="showRenewButton">续费套餐</a-button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="storage-right">
            <a-progress
              type="circle"
              :percent="usagePercent"
              :width="180"
              :stroke-width="12"
              :stroke-color="progressColor"
              trail-color="#e0e0e0"
            >
              <template #format="percent">
                <span style="color: red">{{ `使用率${percent}%` }}</span>
              </template>
            </a-progress>
            <div class="usage-text">已用 {{ usedCapacityText }} / 总计 {{ totalCapacityText }}</div>
          </div>

          <div class="settings-icon">
            <a-icon type="setting" @click="handleShowSmsModal" />
          </div>
        </div>
      </div>

      <a-modal v-model="showSmsModal" title="短信提醒设置" :footer="null" width="700px" :maskClosable="false">
        <div class="sms-modal-content">
          <!-- 现有提醒设置 -->
          <div class="existing-reminders-section" v-if="existingReminders.length > 0">
            <div class="section-title">当前提醒接收人</div>
            <div class="existing-reminder-list">
              <div class="existing-reminder-item" v-for="reminder in existingReminders" :key="reminder.id">
                <div class="reminder-info">
                  <span class="reminder-name">{{ reminder.contactName }}</span>
                  <span class="reminder-phone">{{ reminder.phone }}</span>
                  <!-- <span class="reminder-time" v-if="reminder.createTime">
                    创建时间：{{ formatTime(reminder.createTime) }}
                  </span> -->
                  <a-button
                    type="link"
                    size="small"
                    class="delete-reminder-btn"
                    @click="handleDeleteReminder(reminder)"
                    :loading="deleteLoading === reminder.id"
                  >
                    删除
                  </a-button>
                </div>
              </div>
            </div>
            <a-divider style="margin: 16px 0" />
          </div>

          <!-- 添加/编辑提醒接收人 -->
          <div class="receiver-section" v-if="!existingReminders.length || existingReminders.length < 5">
            <div class="section-title">
              {{
                existingReminders.length > 0
                  ? `添加新接收人（最多5人，当前已有${existingReminders.length}人，还可添加${
                    5 - existingReminders.length
                  }人）`
                  : '提醒接收人（最多5人）'
              }}
            </div>
            <div class="receiver-list">
              <div class="receiver-item" v-for="(receiver, index) in receivers" :key="index">
                <div class="receiver-row">
                  <div class="name-input-wrapper phone-input-wrapper">
                    <a-input
                      v-model="receiver.contactName"
                      placeholder="姓名"
                      class="receiver-input"
                      @blur="validateName(receiver)"
                      @input="handleNameInput(receiver)"
                      :class="{ 'name-error': receiver.nameError }"
                      :maxLength="20"
                    />
                    <div class="name-error-text" v-if="receiver.nameError">
                      {{ receiver.nameError }}
                    </div>
                  </div>
                  <div class="phone-input-wrapper">
                    <a-input
                      v-model="receiver.phone"
                      placeholder="手机号"
                      class="receiver-input"
                      @blur="validatePhone(receiver)"
                      @input="handlePhoneInput(receiver)"
                      :class="{ 'phone-error': receiver.phoneError }"
                      :maxLength="11"
                    />
                    <div class="phone-error-text" v-if="receiver.phoneError">
                      {{ receiver.phoneError }}
                    </div>
                  </div>
                  <a-icon type="close" class="remove-icon" @click="removeReceiver(index)" v-if="receivers.length > 1" />
                </div>
              </div>
            </div>
            <div
              class="add-receiver-btn"
              @click="addReceiver"
              :disabled="
                receivers.length >= 5 - existingReminders.length || existingReminders.length + receivers.length >= 5
              "
            >
              <a-icon type="plus-circle" theme="twoTone" />
              添加接收人
            </div>
            <!-- <div class="receiver-tip" v-if="existingReminders.length > 0">
              <a-alert
                message="提示"
                :description="`当前已有 ${existingReminders.length} 个提醒接收人，最多可设置 5 个，还可添加 ${5 - existingReminders.length} 个`"
                type="info"
                show-icon
                style="margin-top: 12px;"
              />
            </div> -->
          </div>

          <!-- 已达到上限提示 -->
          <div class="receiver-section" v-else>
            <div class="section-title">提醒接收人已满</div>
            <a-alert
              message="提醒接收人已达到上限（5人）"
              description="如需添加新的提醒接收人，请先在上方删除现有的提醒设置。"
              type="warning"
              show-icon
            />
          </div>

          <div class="reminder-content-section">
            <a-icon type="sound" theme="twoTone" />
            <div>
              <div class="tit reminder-text" style="color: #333; font-size: 14px; font-weight: bold">提醒内容</div>
              <div class="reminder-text">套餐到期前发送提醒</div>
            </div>
          </div>

          <div class="modal-footer">
            <a-button @click="showSmsModal = false" class="cancel-btn">取消</a-button>
            <a-button
              type="primary"
              @click="saveSmsSettings"
              :loading="saveLoading"
              class="save-btn"
            >保存设置</a-button
            >
          </div>
        </div>
      </a-modal>

      <div class="storage-overview" style="margin-top: 40px" v-if="hasPackage && archiveList.length > 0">
        <div class="archive-header">
          <h2 class="archive-title">归档存储</h2>
        </div>

        <div class="archive-table">
          <a-table
            :loading="archiveLoading"
            rowKey="id"
            :columns="archiveColumns"
            :data-source="archiveList"
            :pagination="archivePagination"
            @change="handleArchiveTableChange"
            :scroll="{ x: 800 }"
          >
            <span slot="statNo" slot-scope="text">
              <a-tooltip placement="topLeft" :title="text">
                <span class="text-ellipsis">{{ text || '-' }}</span>
              </a-tooltip>
            </span>

            <span slot="expireTime" slot-scope="text">
              <a-tooltip placement="topLeft" :title="formatTime(text)">
                <span class="text-ellipsis">{{ formatTime(text) }}</span>
              </a-tooltip>
            </span>

            <span slot="totalArchiveCapacity" slot-scope="text">
              <a-tooltip placement="topLeft" :title="$formatCapacity(text)">
                <span class="capacity-text text-ellipsis">{{ $formatCapacity(text) }}</span>
              </a-tooltip>
            </span>

            <span slot="renewType" slot-scope="text">
              <a-tag :color="getArchiveRenewTypeColor(text)">
                {{ getArchiveRenewTypeText(text) }}
              </a-tag>
            </span>

            <span slot="archiveSceneCount" slot-scope="text">
              <span>{{ text || 0 }} 个场景</span>
            </span>

            <span slot="renewAmount" slot-scope="text">
              <span v-if="text">¥{{ text }}</span>
              <span v-else>-</span>
            </span>

            <span slot="action" slot-scope="text, record">
              <a-button
                type="link"
                size="small"
                v-hasPermi="['961c4bf184878299c0760852dfce6474q:0:q']"
                @click="handleArchiveDetail(record)"
              >查看详情</a-button
              >
              <a-divider type="vertical" />
              <a-button type="link" size="small" @click="handleArchiveRenew(record)">续费</a-button>
            </span>
          </a-table>
        </div>
      </div>

      <div class="storage-overview" style="margin-top: 40px" v-if="!pageLoading && !hasPackage">
        <div class="card-content">
          <div class="prompt-message">
            <div class="message-icon">
              <img
                src="http://hoy-test-1308702491.cos.ap-beijing.myqcloud.com/hoy/oth/IMG_20251105_134842__265773.png"
                alt=""
              />
            </div>
            <div class="message-title">您尚未购买存储套餐</div>
            <div class="message-content">请购买合适的存储套餐以开始使用我们的存储空间服务</div>
          </div>
          <div class="action-button">
            <a-button type="primary" class="purchase-btn" @click="goToPay(1)">立即购买套餐</a-button>
          </div>
        </div>
      </div>

      <div class="storage-overview" style="margin-top: 40px" v-if="hasPackage">
        <UsageDetails :storagePoolId="getUsageDetailsStoragePoolId" />
      </div>

      <div class="storage-alert" style="margin-top: 40px" v-if="hasPackage && currentStorage.type === 0">
        <div class="alert-content">
          <div class="alert-text" style="display: flex; justify-content: space-between; align-items: center">
            <a-icon v-if="usagePercent >= 85" type="exclamation-circle" class="alert-icon" />
            <div class="alert-title">
              <template v-if="usagePercent >= 85">
                存储空间即将用完
                <div class="alert-desc">您的存储空间已使用 {{ usagePercent }}%，建议购买扩容包以避免存储不足</div>
              </template>
              <template v-else>
                存储空间扩容包加油站
                <div class="alert-desc">
                  您的存储空间已使用 {{ usagePercent }}%，想购买扩容包可点击购买扩容包，扩容哦
                </div>
              </template>
            </div>
          </div>
          <a-button type="primary" @click="goToPay(3)">购买扩容包</a-button>
        </div>
      </div>

      <ArchiveDetailDrawer ref="archiveDetailDrawer" />
      <ArchiveRenewModal ref="archiveRenewModal" @success="handleRenewSuccess" />
    </a-spin>
  </div>
</template>

<script>
import { getStorageInfo, getArchiveList } from '@/api/VR/storage'
import { addRemindSettings, getRemindSettingsPage, deleteRemindSettings } from '@/api/system/remind'
import UsageDetails from './components/UsageDetails.vue'
import ArchiveDetailDrawer from './modules/ArchiveDetailDrawer.vue'
import ArchiveRenewModal from './modules/ArchiveRenewModal.vue'
import { message } from 'ant-design-vue'

export default {
  name: 'StorageOverview',
  components: { UsageDetails, ArchiveDetailDrawer, ArchiveRenewModal },
  data() {
    return {
      pageLoading: false,
      loading: false,
      selectedTenant: null,
      tenants: [],
      storageData: [],
      archiveLoading: false,
      archiveList: [],
      archiveQueryParam: {
        pageNum: 1,
        pageSize: 10,
        dueToExpire: 1,
      },
      archivePagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: (total) => `共 ${total} 条`,
      },
      archiveColumns: [
        {
          title: '统计单号',
          dataIndex: 'statNo',
          key: 'statNo',
          width: 220,
          scopedSlots: { customRender: 'statNo' },
          align: 'center',
        },
        {
          title: '归档到期',
          dataIndex: 'expireTime',
          key: 'expireTime',
          scopedSlots: { customRender: 'expireTime' },
          align: 'center',
        },
        {
          title: '归档存储量',
          dataIndex: 'totalArchiveCapacity',
          key: 'totalArchiveCapacity',
          scopedSlots: { customRender: 'totalArchiveCapacity' },
          align: 'center',
        },
        {
          title: '归档存储模式',
          dataIndex: 'renewType',
          key: 'renewType',
          scopedSlots: { customRender: 'renewType' },
          align: 'center',
        },
        {
          title: '操作',
          key: 'action',
          width: 150,
          fixed: 'right',
          scopedSlots: { customRender: 'action' },
          align: 'center',
        },
      ],
      showSmsModal: false,
      receivers: [{ contactName: '', phone: '', phoneError: '', nameError: '' }],
      saveLoading: false,
      deleteLoading: null, // 删除操作的加载状态
      existingReminders: [], // 存储现有的提醒设置
    }
  },
  computed: {
    getType() {
      // 获取 Vuex store 中的用户信息
      const user = this.$store.state.user || {}
      // 检查用户是否存在租户信息
      if (user && user.userTentant) {
        // 如果存在租户信息，返回租户类型
        const tenantType = user.userTentant.type
        return tenantType
      } else {
        // 如果不存在租户信息，返回 null
        console.log(null, 'getType')
        return null
      }
    },

    showShareButton() {
      console.log(this.currentStorage.type, 'showShareButton')
      if (!this.hasPackage || this.currentStorage.type !== 0) return false
      return true
    },
    currentStorage() {
      if (!this.storageData.length) return {}

      if (this.selectedTenant) {
        return this.storageData.find((item) => item.id === this.selectedTenant) || this.storageData[0]
      }

      return this.storageData[0]
    },
    hasPackage() {
      if (!this.storageData.length || this.currentStorage.id === '0') return false

      const storage = this.currentStorage
      return !(storage.packageId === 0 && storage.type === 0 && storage.id === 0)
    },
    isExpired() {
      if (!this.hasPackage || !this.currentStorage.expireTime) return false
      return new Date(this.currentStorage.expireTime) < new Date()
    },
    isNearExpiry() {
      if (!this.hasPackage || !this.currentStorage.expireTime) return false

      const expireDate = new Date(this.currentStorage.expireTime)
      const threeMonthsLater = new Date()
      threeMonthsLater.setMonth(threeMonthsLater.getMonth() + 3)

      return expireDate <= threeMonthsLater && expireDate > new Date()
    },
    showRenewButton() {
      if (!this.hasPackage) return false

      return this.currentStorage.type === 0 && (this.isNearExpiry || this.isExpired)
    },
    showStorageAlert() {
      if (!this.hasPackage) return false
      return this.usagePercent > 60
    },
    packageName() {
      if (!this.hasPackage) return '未购买'

      const storage = this.currentStorage
      if (storage.type === 0) {
        return `自购套餐 `
      } else if (storage.type === 1) {
        return `企业套餐`
      } else {
        return `套餐`
      }
    },
    storageMode() {
      if (!this.hasPackage) return '-'
      return this.currentStorage.renewType === 1 ? '安心存储' : '灵活存储'
    },
    effectiveTime() {
      if (!this.hasPackage) return '-'

      const dateStr = this.currentStorage.lastStatDate || new Date().toISOString()
      const date = new Date(dateStr)
      return date.toLocaleDateString()
    },
    expireTimeText() {
      if (!this.hasPackage) return '-'
      if (!this.currentStorage.expireTime) return '-'

      const date = new Date(this.currentStorage.expireTime)
      return date.toLocaleDateString()
    },
    usagePercent() {
      if (!this.hasPackage) return 0

      const totalUsed = this.currentStorage.totalUsedCapacity || 0
      const totalCapacity = this.currentStorage.totalATotalCapacity || 0

      if (totalCapacity === 0) return 0

      const percent = (totalUsed / totalCapacity) * 100
      return Math.min(Number(percent.toFixed(2)), 100)
    },
    progressColor() {
      if (this.usagePercent > 90) return '#ff4d4f'
      if (this.usagePercent > 70) return '#faad14'
      return '#1890ff'
    },
    usedCapacityText() {
      if (!this.hasPackage) return '0MB'
      const totalUsed = this.currentStorage.totalUsedCapacity || 0
      return this.$formatCapacity(totalUsed)
    },
    totalCapacityText() {
      if (!this.hasPackage) return '0MB'
      const totalCapacity = this.currentStorage.totalATotalCapacity || 0
      return this.$formatCapacity(totalCapacity)
    },
    remainingStorage() {
      if (!this.hasPackage) return 0
      const totalUsed = this.currentStorage.totalResultRemainingCapacity || 0
      return totalUsed
    },
    getUsageDetailsStoragePoolId() {
      if (!this.currentStorage || !this.currentStorage.id) return ''
      return this.currentStorage.id || ''
    },
  },
  mounted() {
    this.fetchStorageData()
  },
  watch: {
    selectedTenant() {
      if (this.hasPackage) {
        this.fetchArchiveData()
      }
    },
  },
  methods: {
    handleArchiveDetail(record) {
      this.$refs.archiveDetailDrawer.show(record)
    },
    handleArchiveRenew(record) {
      this.$refs.archiveRenewModal.show(record)
    },
    handleRenewSuccess() {
      this.fetchArchiveData()
      message.success('续费成功')
    },
    async fetchStorageData() {
      try {
        this.pageLoading = true
        this.loading = true
        const response = await getStorageInfo()

        if (response && Array.isArray(response.data)) {
          this.storageData = response.data

          if (this.storageData.length > 0) {
            this.tenants = this.storageData.map((item) => ({
              id: item.id,
              name: item.tenantName,
            }))

            this.selectedTenant = this.tenants[0].id

            if (this.hasPackage) {
              await this.fetchArchiveData()
            }
          }
        } else {
          this.storageData = []
        }
      } catch (error) {
        console.error('获取存储套餐信息失败:', error)
        message.error('获取存储套餐信息失败')
        this.storageData = []
      } finally {
        this.pageLoading = false
        this.loading = false
      }
    },
    async fetchArchiveData() {
      if (!this.currentStorage || !this.currentStorage.id) {
        return
      }

      try {
        this.archiveLoading = true

        const params = {
          ...this.archiveQueryParam,
        }

        const response = await getArchiveList(params)

        if (response && response.success) {
          this.archiveList = response.data.records || []
          this.archivePagination.total = response.data.total
          this.archivePagination.current = response.data.current
        } else {
          this.archiveList = []
          this.archivePagination.total = 0
        }
      } catch (error) {
        console.error('获取归档存储列表失败:', error)
        message.error('获取归档存储列表失败')
        this.archiveList = []
      } finally {
        this.archiveLoading = false
      }
    },
    handleTenantChange(tenantId) {
      this.selectedTenant = tenantId
    },
    formatTime(time) {
      if (!time) return '-'
      return new Date(time).toLocaleDateString()
    },
    handleShareCapacity() {
      if (!this.currentStorage || !this.currentStorage.id) {
        this.$message.warning('请先选择有效的存储池')
        return
      }

      // 将当前选择的存储信息存储到 Vuex
      this.$store.commit('SET_CURRENT_STORAGE', this.currentStorage)

      const query = {
        storagePoolId: this.currentStorage.id,
      }

      this.$router.push({
        name: 'TrafficAllocation',
        query: query,
      })
    },
    handleRenew(e) {
      // 根据存储模式决定请求类型
      // 0: 标准, 1: 安心存储, 2: 灵活存储
      const renewType = this.currentStorage.renewType === 2 ? 2 : 1

      const query = {
        type: renewType,
        id: this.currentStorage.packageId || '',
      }
      this.$router.push({
        name: 'BuyNow',
        query,
      })
    },
    goToPay(e) {
      const query = {
        type: e,
        packagePid: e === 3 ? this.currentStorage.packageId : '',
      }
      this.$router.push({
        name: 'BuyNow',
        query,
      })
    },
    handleArchiveTableChange(pagination, filters, sorter) {
      this.archiveQueryParam.pageNum = pagination.current
      this.archiveQueryParam.pageSize = pagination.pageSize
      this.fetchArchiveData()
    },
    getArchiveRenewTypeText(type) {
      const typeMap = {
        0: '标准',
        1: '安心存储',
        2: '灵活存储',
      }
      return typeMap[type] || '-'
    },
    getArchiveRenewTypeColor(type) {
      const colorMap = { 0: 'blue', 1: 'green', 2: 'orange' }
      return colorMap[type] || 'default'
    },
    validatePhone(receiver) {
      if (!receiver.phone || receiver.phone.trim() === '') {
        receiver.phoneError = '请输入手机号'
        return false
      }
      const phoneRegex =
        /^(?:(?:\+|00)86)?1(?:(?:3[\d])|(?:4[5-79])|(?:5[0-35-9])|(?:6[5-7])|(?:7[0-8])|(?:8[\d])|(?:9[1589]))\d{8}$/
      if (!phoneRegex.test(receiver.phone.trim())) {
        receiver.phoneError = '请输入正确的手机号格式'
        return false
      }

      receiver.phoneError = ''
      return true
    },

    validateName(receiver) {
      if (!receiver.contactName || receiver.contactName.trim() === '') {
        receiver.nameError = '请输入姓名'
        return false
      }

      receiver.nameError = ''
      return true
    },
    handlePhoneInput(receiver) {
      // 只允许输入数字
      receiver.phone = receiver.phone.replace(/\D/g, '')

      // 实时校验手机号格式（当输入长度达到11位时）
      if (receiver.phone.length === 11) {
        this.validatePhone(receiver)
      } else if (receiver.phone.length > 0) {
        // 清除错误信息，但保持部分输入状态
        if (receiver.phoneError && receiver.phoneError !== '请输入正确的手机号格式') {
          receiver.phoneError = ''
        }
      } else {
        receiver.phoneError = ''
      }
    },

    handleNameInput(receiver) {
      // 实时校验姓名
      if (receiver.contactName && receiver.contactName.trim() !== '') {
        this.validateName(receiver)
      } else if (receiver.contactName.length > 0) {
        // 清除错误信息
        receiver.nameError = ''
      } else {
        receiver.nameError = ''
      }
    },
    addReceiver() {
      const maxNewReceivers = 5 - this.existingReminders.length
      if (this.receivers.length < maxNewReceivers) {
        this.receivers.push({ contactName: '', phone: '', phoneError: '', nameError: '' })
      }
    },
    removeReceiver(index) {
      if (this.receivers.length > 1) {
        this.receivers.splice(index, 1)
      }
    },
    async handleShowSmsModal() {
      await this.fetchExistingReminders()
      this.showSmsModal = true
    },
    async fetchExistingReminders() {
      try {
        const params = {
          pageNum: 1,
          pageSize: 10,
        }

        const response = await getRemindSettingsPage(params)

        if (response && response.success && response.data && response.data.records) {
          this.existingReminders = response.data.records
        } else {
          this.existingReminders = []
        }

        // 根据现有接收人数量初始化编辑区域
        const maxNewReceivers = 5 - this.existingReminders.length
        // 如果已有接收人达到上限，则不显示添加区域
        if (maxNewReceivers <= 0) {
          this.receivers = []
        } else {
          // 初始化一个空的接收人表单
          this.receivers = [{ contactName: '', phone: '', phoneError: '', nameError: '' }]
        }
      } catch (error) {
        console.error('查询提醒设置失败:', error)
        this.existingReminders = []
        this.receivers = [{ contactName: '', phone: '', phoneError: '', nameError: '' }]
      }
    },
    async saveSmsSettings() {
      // 先校验所有姓名和手机号格式
      let hasNameError = false
      let hasPhoneError = false
      for (const receiver of this.receivers) {
        if (receiver.contactName.trim() || receiver.phone.trim()) {
          if (!this.validateName(receiver)) {
            hasNameError = true
          }
          if (!this.validatePhone(receiver)) {
            hasPhoneError = true
          }
        }
      }

      if (hasNameError || hasPhoneError) {
        message.warning('请修正姓名或手机号格式错误')
        return
      }

      const validReceivers = this.receivers.filter((receiver) => receiver.contactName.trim() && receiver.phone.trim())

      if (validReceivers.length === 0) {
        message.warning('请至少填写一个有效的接收人信息')
        return
      }

      // 检查总数限制
      const totalReceivers = this.existingReminders.length + validReceivers.length
      if (totalReceivers > 5) {
        message.warning(
          `提醒接收人总数不能超过5人，当前已有${this.existingReminders.length}人，最多还能添加${
            5 - this.existingReminders.length
          }人`
        )
        return
      }

      // 检查新添加的接收人数量是否超过限制
      const maxNewReceivers = 5 - this.existingReminders.length
      if (validReceivers.length > maxNewReceivers) {
        message.warning(`当前已有${this.existingReminders.length}个接收人，最多只能再添加${maxNewReceivers}个新接收人`)
        return
      }

      // 检查重复的手机号
      // const existingPhones = this.existingReminders.map(item => item.phone)
      // const newPhones = validReceivers.map(item => item.phone.trim())
      // const duplicatePhones = newPhones.filter(phone => existingPhones.includes(phone))
      // if (duplicatePhones.length > 0) {
      //   message.warning('手机号已存在于现有提醒设置中，请勿重复添加')
      //   return
      // }

      try {
        this.saveLoading = true

        const newReceivers = validReceivers.filter((receiver) => !receiver.id)

        if (newReceivers.length === 0) {
          message.warning('没有新的接收人需要添加')
          return
        }

        const requests = []

        // 新增的提醒设置
        newReceivers.forEach((receiver) => {
          requests.push(
            addRemindSettings({
              contactName: receiver.contactName.trim(),
              phone: receiver.phone.trim(),
            })
          )
        })

        await Promise.all(requests)

        message.success(`成功添加${newReceivers.length}个提醒接收人`)
        this.showSmsModal = false
        this.receivers = [{ contactName: '', phone: '', phoneError: '' }]
        this.existingReminders = []
      } catch (error) {
        console.error('保存短信提醒设置失败:', error)
        message.error('保存短信提醒设置失败，请重试')
      } finally {
        this.saveLoading = false
      }
    },
    async handleDeleteReminder(reminder) {
      this.$confirm({
        title: '确认删除',
        content: `确定要删除 ${reminder.contactName} 的提醒设置吗？`,
        okText: '确认',
        cancelText: '取消',
        onOk: async () => {
          try {
            this.deleteLoading = reminder.id

            const response = await deleteRemindSettings([{ id: reminder.id }])

            if (response && response.success) {
              message.success('删除成功')
              // 重新查询现有提醒设置
              await this.fetchExistingReminders()
            } else {
              message.error('删除失败，请重试')
            }
          } catch (error) {
            console.error('删除提醒设置失败:', error)
            message.error('删除失败，请重试')
          } finally {
            this.deleteLoading = null
          }
        },
      })
    },
  },
}
</script>

<style scoped>
.storage-alert {
  background: #fff;
  padding: 16px 20px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
}

.alert-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.alert-icon {
  color: #ffa940;
  font-size: 18px;
  margin-right: 12px;
  margin-top: 2px;
}

.alert-title {
  font-size: 14px;
  font-weight: 600;
  color: #000000;
  line-height: 1.5;
  margin-bottom: 2px;
}

.alert-desc {
  font-size: 12px !important;
  color: #666666 !important;
  font-weight: 100 !important;
  line-height: 1.5;
}

.storage-overview {
  background: #ffffff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  margin: 0 auto;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  position: relative;
}

.settings-icon {
  position: absolute;
  top: 20px;
  right: 20px;
  font-size: 18px;
  cursor: pointer;
  transition: color 0.3s;
}

.settings-icon:hover {
  color: #40a9ff;
}

.archive-header {
  margin-bottom: 20px;
}

.archive-title {
  font-size: 18px;
  font-weight: 600;
  color: #000000;
  margin: 0;
}

.archive-table {
  margin-top: 16px;
}

.capacity-text {
  font-weight: 600;
  color: #1890ff;
}

.card-header {
  margin-bottom: 20px;
}

.info-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  gap: 20px;
}

.info-left {
  flex: 0 0 auto;
  min-width: 420px;
}

.info-grid {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  max-width: 400px;
  margin-left: 30px;
}

.info-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  align-items: start;
}

.info-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-height: 50px;
}

.info-label {
  font-size: 14px;
  color: #666666;
  line-height: 1.5;
  white-space: nowrap;
}

.info-value {
  font-size: 14px;
  font-weight: bold;
  color: #000000;
  line-height: 1.5;
  word-break: break-word;
  min-height: 20px;
}

.expired {
  color: #ff4d4f;
}

.storage-section {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 16px;
}

.storage-left {
  display: flex;
  gap: 20px;
  background: #eff6ff;
  align-items: center;
  padding: 12px;
  border-radius: 12px;
  margin-left: 30px;
}

.storage-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.storage-label {
  font-size: 14px;
  color: #666666;
  line-height: 1.5;
}

.storage-value {
  font-size: 20px;
  font-weight: 600;
  color: #000000;
  line-height: 1.2;
}

.storage-actions {
  display: flex;
  align-items: center;
}

.storage-right {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  justify-content: center;
  margin-right: 50px;
}

.storage-right .storage-actions {
  margin-top: 8px;
}

.usage-text {
  font-size: 14px;
  color: #000000;
  line-height: 1.5;
  text-align: center;
}

.card-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.prompt-message {
  text-align: center;
  padding: 16px 0;
}

.message-icon img {
  width: 60px;
  height: 60px;
  margin-bottom: 16px;
  border-radius: 50%;
}

.message-title {
  font-size: 16px;
  font-weight: bold;
  color: #262626;
  line-height: 1.5;
  margin-bottom: 4px;
}

.message-content {
  font-size: 14px;
  color: #666666;
  line-height: 1.5;
}

.action-button {
  text-align: center;
}

.purchase-btn {
  height: 40px;
  padding: 0 24px;
  font-size: 14px;
  font-weight: 500;
  border-radius: 6px;
  background: #1890ff;
  border-color: #1890ff;
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);
}

.purchase-btn:hover,
.purchase-btn:focus {
  background: #40a9ff;
  border-color: #40a9ff;
}

.sms-modal-content {
  padding: 0;
}

.section-title {
  font-size: 14px;
  font-weight: 600;
  color: #000000;
  margin-bottom: 12px;
}

.existing-reminders-section {
  margin-bottom: 20px;
}

.existing-reminder-list {
  background: #f8f9fa;
  border-radius: 6px;
  padding: 12px;
}

.existing-reminder-item {
  padding: 8px 0;
  border-bottom: 1px solid #e8e8e8;
}

.existing-reminder-item:last-child {
  border-bottom: none;
}

.reminder-info {
  display: flex;
  align-items: center;
  gap: 26px;
  flex-wrap: wrap;
}

.reminder-name {
  font-weight: 500;
  color: #262626;
  min-width: 80px;
}

.reminder-phone {
  color: #1890ff;
  font-family: monospace;
}

.reminder-time {
  color: #8c8c8c;
  font-size: 12px;
}

.delete-reminder-btn {
  color: #ff4d4f;
  padding: 0;
  height: auto;
  font-size: 12px;
  margin-left: auto;
}

.delete-reminder-btn:hover {
  color: #ff7875;
}

.receiver-section {
  margin-bottom: 24px;
  border-bottom: 1px solid #f0f0f0;
}

.receiver-list {
  margin-bottom: 16px;
}

.receiver-item {
  margin-bottom: 12px;
}

.receiver-row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  flex-wrap: wrap;
}

.receiver-input {
  flex: 1;
  min-width: 150px;
  min-height: 32px; /* 固定输入框高度 */
}

.phone-input-wrapper {
  flex: 1;
  min-width: 150px;
  display: flex;
  flex-direction: column;
}

.receiver-input.phone-error {
  border-color: #ff4d4f;
  box-shadow: 0 0 0 2px rgba(255, 77, 79, 0.2);
}

.receiver-input.name-error {
  border-color: #ff4d4f;
  box-shadow: 0 0 0 2px rgba(255, 77, 79, 0.2);
}

.phone-error-text {
  color: #ff4d4f;
  font-size: 12px;
  line-height: 1.5;
  margin-top: 2px;
  margin-left: 4px;
  white-space: nowrap;
  height: 18px; /* 固定错误信息高度 */
}

.name-error-text {
  color: #ff4d4f;
  font-size: 12px;
  line-height: 1.5;
  margin-top: 2px;
  margin-left: 4px;
  white-space: nowrap;
  height: 18px; /* 固定错误信息高度 */
}

.remove-icon {
  color: #ff4d4f;
  cursor: pointer;
  font-size: 14px;
  margin-top: 8px;
  flex-shrink: 0;
}

.remove-icon:hover {
  color: #ff7875;
}

.add-receiver-btn {
  height: 40px;
  color: #4e80ee;
}

.add-receiver-btn:hover {
  border-color: #1890ff;
  color: #1890ff;
}

.add-receiver-btn:disabled {
  color: #ccc;
  border-color: #d9d9d9;
  cursor: not-allowed;
}

.reminder-content-section {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;
}

.reminder-text {
  font-size: 12px;
  color: #666;
  border-radius: 6px;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
}

.cancel-btn {
  width: 80px;
  height: 36px;
}

.save-btn {
  width: 80px;
  height: 36px;
}

.text-ellipsis {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}

.ant-table-thead > tr > th,
.ant-table-tbody > tr > td {
  text-align: center;
  vertical-align: middle;
}

@media (max-width: 768px) {
  .storage-overview {
    padding: 16px;
    margin: 16px;
  }

  .info-grid {
    max-width: 100%;
  }

  .info-row {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .storage-section {
    flex-direction: column;
    gap: 24px;
  }

  .storage-left {
    justify-content: space-between;
    width: 100%;
  }

  .storage-right {
    width: 100%;
    min-width: auto;
    margin-right: 0;
  }

  .receiver-item {
    margin-bottom: 12px;
  }

  .receiver-row {
    flex-direction: column;
    gap: 8px;
  }

  .receiver-input {
    width: 100%;
  }
}
</style>
